import React, { useEffect, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

function PortsAutoComplete({ 
    selectValue, 
    customValue = '',
    style = {}, 
    textFieldStyle = {}, 
    underlineStyle = {}, 
    floatingLabelStyle = {}, 
    hintText,
    menuStyle = {},
    popoverProps = {},
    inputStyle = {},
    field = '',
    handleChangeCustomValue = () => {},
    withAreas = false,
    // mainRegions,
    onlyAreas,
    shouldClearCustomValue = false,
    // isInBalticIndex,
    disabled = false,
}) {
    const [portValue, setPortValue] = useState(customValue);
    const [ports, setPorts] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);

    const debouncedSearchValue = useDebounce(portValue, 500);

    useEffect(() => {
        setPortValue('');
    }, [shouldClearCustomValue]);

    useEffect(() => {
        if (preventFirstSearch) return;

        if (!debouncedSearchValue || debouncedSearchValue.length < 2) {
            handleChangeCustomValue({});
            return;
        }

        api
            .findPortAdmin({ name: debouncedSearchValue, withAreas, onlyAreas })
            .then((result) => {
                setPorts(result.data.data);
            });
    }, [debouncedSearchValue]);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    useEffect(() => {
        setPortValue(customValue);
    }, [customValue]);

    const choosePort = async (selectedValue, index) => {
        if (index < 0) {
            return;
        }
        await selectValue(selectedValue);
    };

    const changePortValue = (val) => {
        setPortValue(val);
    };

    return (
        <AutoComplete 
            name='port'
            value={portValue}
            searchText={portValue}
            dataSource={ports}
            dataSourceConfig={{ text: field || 'name', value: 'item' }}
            hintText={hintText === null ? null : (hintText || 'Port')}
            onUpdateInput={val => changePortValue(val)}
            onNewRequest={(val, index) => choosePort(val, index)}
            filter={AutoComplete.noFilter}
            textFieldStyle={{ fontSize: '13px', ...textFieldStyle }}
            style={style}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            fullWidth={!style.width}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                ...popoverProps,
            }}
            menuStyle={{ ...menuStyle }}
            disabled={disabled}
        />
    );
}

export default PortsAutoComplete;



// WEBPACK FOOTER //
// ./app/components/common/PortsAutoComplete.jsx